import React from "react";
import EventCard from "../components/EventCard";
import SectionHeading from "../components/SectionHeading";

/**
 * Events page
 * Props:
 *  - content: siteContent.events
 */
function Events({ content }) {
  return (
    <>
      <section className="hero-section py-5">
        <div className="container text-center">
          <h1 className="fw-bold display-6 mb-2">{content.title}</h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>{content.heroTagline}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="What's on" title="Upcoming & Past Events" />
          <div className="row g-4">
            {content.list.map((event) => (
              <div className="col-md-6 col-lg-3" key={event.id}>
                <EventCard event={event} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Events;
